import jQuery from "jquery";

(function ($) {
    const $hoverImage = $('.list-image-hover');
    const $linkContent = $('.link-content');

    if (!$hoverImage.length) return;

    const debounce = (func, delay) => {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const updateHoverPosition = (e) => {
        $hoverImage.css({ top: e.clientY });
    };

    $linkContent.on('mousemove', debounce(updateHoverPosition, 100)); // Adjust delay as needed
})(jQuery);